import { useQuery } from "@tanstack/react-query";

import { popularAppsForSearchSuggestionsKey } from "@/hooks/apis/queries/usePopularAppsForSearchSuggestionsQuery/constants";

import { applicationsApiHandler } from "@/services/apiHandlers/applications";

const usePopularAppsForSearchSuggestionsQuery = () => {
  const {
    data: popularAppsForSearchSuggestions,
    isLoading: isLoadingPopularAppsForSearchSuggestions,
  } = useQuery({
    queryKey: [popularAppsForSearchSuggestionsKey],
    queryFn: () => applicationsApiHandler.getPopularApps(),
  });

  return {
    popularAppsForSearchSuggestions,
    isLoadingPopularAppsForSearchSuggestions,
  };
};

export default usePopularAppsForSearchSuggestionsQuery;
